
import Slider from "react-slick";
import client1 from "../../../../assets/images/all-img/client1.png";
import client2 from "../../../../assets/images/all-img/client2.png";
import client3 from "../../../../assets/images/all-img/client3.png";
import client4 from "../../../../assets/images/all-img/client4.png";
import client5 from "../../../../assets/images/all-img/client5.png";

export default function ClientSliderOne() {
	const settings = {
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 10000,
		cssEase: "linear",
		pauseOnHover: true,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	};
	return (
		<div className="fugu-client-section bg-gray-800">
			<div className="container">
				<div className="fugu-client-title text-white">
					<h5>Trusted by 1600+ of the world most popular companies</h5>
				</div>
				<div className="fugu-client-slider">
					<Slider {...settings}>
						<div className="fugu-brand-logo">
							<img src={client1} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client2} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client3} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client4} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client5} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client1} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client2} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client3} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client4} alt="" />
						</div>
						<div className="fugu-brand-logo">
							<img src={client5} alt="" />
						</div>
					</Slider>
				</div>
			</div>
		</div>
	);
}
